var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import CountryLanguagePicker from '../../inputs/CountryLanguagePicker';
import { processLanguageExceptions } from '../../../utils/translations.util';
var LEGACY_LANGUAGE_CODES = { D: 'de', E: 'en' };
var NO_LANGUAGES = [];
var visibleCode = function (code) { var _a; return (_a = LEGACY_LANGUAGE_CODES[code]) !== null && _a !== void 0 ? _a : code.toLowerCase(); };
var FilterLanguageInput = function (_a) {
    var _b = _a.ids, ids = _b === void 0 ? NO_LANGUAGES : _b, setIds = _a.setIds, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var selected = useMemo(function () { return Array.from(new Set(ids.map(visibleCode))); }, [ids]);
    return _jsx(CountryLanguagePicker, { kind: "language", multiple: true, value: selected, disabled: disabled, onChange: function (codes) {
            // One visible German/English choice covers the existing legacy aliases. Keep raw
            // stored values for retained choices; newly selected languages follow the old writer.
            var retained = ids.filter(function (id) { return codes.includes(visibleCode(id)); });
            var added = codes.filter(function (code) { return !selected.includes(code); });
            setIds(__spreadArray(__spreadArray([], retained, true), processLanguageExceptions(added), true));
        } });
};
export default FilterLanguageInput;
